<template>
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 35 36"
    fill="currentColor"
  >
    <path
      d="M30.8,1.5c-.6-.7-1.6-.8-2.4-.2-.7.6-.9,1.5-.3,2.2,3.9,4.6,3.9,11.4,0,16-.6.7-.5,1.7.3,2.2.3.2.7.3,1.1.3.5,0,1-.2,1.3-.6,4.9-5.8,4.9-14.2,0-20.1Z"
    />
    <path
      d="M26,5.1c-.6-.7-1.6-.8-2.4-.3s-.9,1.5-.3,2.2c2.2,2.6,2.2,6.3,0,8.9-.6.7-.5,1.7.3,2.2.3.2.7.3,1.1.3.5,0,1-.2,1.3-.6,3.2-3.7,3.2-9.1,0-12.8Z"
    />
    <path
      d="M6.8,3.5c.6-.7.5-1.7-.3-2.2-.7-.6-1.8-.4-2.4.2C-.8,7.3-.8,15.7,4.2,21.5c.4.4.8.6,1.3.6s.7-.1,1.1-.3c.7-.6.9-1.5.3-2.2-3.9-4.6-3.9-11.4,0-16Z"
    />
    <path
      d="M11.3,18.2c.7-.6.9-1.5.3-2.2-2.1-2.6-2.1-6.3,0-8.9.6-.7.5-1.7-.3-2.2-.7-.6-1.8-.4-2.4.3-3.1,3.7-3.1,9.1,0,12.8.4.4.8.6,1.3.6s.7-.1,1.1-.3Z"
    />
    <path
      d="M20.3,15.1c1.1-.8,1.9-2.1,1.9-3.6,0-2.4-2.1-4.4-4.7-4.4s-4.8,2-4.8,4.4.7,2.7,1.9,3.6l-5.6,18.8c-.2.8.3,1.7,1.2,2,.2,0,.3,0,.5,0,.7,0,1.4-.4,1.6-1.2l.5-1.9h9.2l.5,1.9c.2.7.9,1.2,1.6,1.2s.3,0,.5,0c.9-.3,1.4-1.1,1.2-2l-5.6-18.8ZM17.5,10.3c.7,0,1.3.6,1.3,1.2s-.6,1.3-1.3,1.3-1.4-.6-1.4-1.3.6-1.2,1.4-1.2ZM19.3,23.6h-3.7l1.8-6.2,1.8,6.2ZM13.9,29.7l.9-2.8h5.6l.9,2.8h-7.3Z"
    />
  </svg>
</template>
